"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _draftJs = require("draft-js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Media extends _react.Component {
  render() {
    const block = this.props.block;
    const entityKey = block.getEntityAt(0);
    const entity = entityKey ? _draftJs.Entity.get(entityKey) : undefined;
    if (!entity) {
      // TODO: Remove behavior this code implemented because wasn't
      // control for media block
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "remove-block"
      });
    }
    const _entity$getData = entity.getData(),
      href = _entity$getData.href,
      target = _entity$getData.target,
      mediaProps = (0, _objectWithoutProperties2.default)(_entity$getData, ["href", "target"]);
    const entityType = entity.getType().toLowerCase();
    if (entityType === 'image') {
      const media = /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, mediaProps, {
        alt: ""
      }));
      if (href) {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: href,
          target: target || '_blank'
        }, media);
      }
      return media;
    } else if (entityType === 'iframe' || entityType === 'script') {
      // insert script or iframe in div
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "noscript",
        dangerouslySetInnerHTML: {
          __html: mediaProps.src
        }
      });
    } else {
      throw new Error('Sorry, media type not found.');
    }
  }
}
var _default = exports.default = Media;